import React from "react";
import { css, jsx } from "@emotion/react";
import InnerHTML from "dangerously-set-html-content";
import { CustomizerContext } from "./CustomizerContext";
import { Box } from "reflexbox";

export function Preview({ previewCode }) {
	let { darkMode } = React.useContext(CustomizerContext);
	// let [previewCode, setpreviewCode] = PreviewCodeState;

	// if (!previewCode) return null;

	return (
		<Box
			py={4}
			css={css`
				${darkMode === true && `background-color: #333`}
			`}
		>
			{/* {JSON.stringify(previewCode)} */}
			<InnerHTML html={previewCode} />
		</Box>
	);
}
